export type Month = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type DayOfMonth =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31;

export type Hour =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23;

export type MinuteOrSecond =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57
  | 58
  | 59;

export interface LocalDate {
  year: number;
  month: Month;
  day: DayOfMonth;
}

export interface LocalTime {
  hour: Hour;
  minute: MinuteOrSecond;
}

/**
 * A dedicated type for date with time.
 */
export interface LocalDateTime extends LocalDate, LocalTime {
  second: MinuteOrSecond;
}

/**
 * type to represent a period of time with begin and end time.
 */
export type PeriodTime = readonly [LocalTime, LocalTime];

export type TimeUnit = 'minutes' | 'hours' | 'days';

export type Day = 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN';

export function buildLocalDate(year: number, month: number, day: number): LocalDate {
  if (month < 1 || month > 12) {
    throw new Error('Month must be in [1-12] range');
  }
  if (day < 1 || day > 31) {
    throw new Error('Day must be in [1-31] range');
  }
  return {
    year,
    month: month as Month,
    day: day as DayOfMonth,
  };
}

export function buildLocalTime(hour: number, minute: number): LocalTime {
  if (hour < 0 || hour > 23) {
    throw new Error('Hour must be in [0-23] range');
  }
  if (minute < 0 || minute > 59) {
    throw new Error('Minute must be in [0-59] range');
  }
  return {
    hour: hour as Hour,
    minute: minute as MinuteOrSecond,
  };
}

export function buildLocalDateTime(
  year: number,
  month: number,
  day: number,
  hour: number,
  minute: number,
  second: number
) {
  if (second < 0 || second > 59) {
    throw new Error('Second must be in [0-59] range');
  }
  return {
    ...buildLocalDate(year, month, day),
    ...buildLocalTime(hour, minute),
    second: second as MinuteOrSecond,
  };
}
